import React, { useEffect, useRef, useState } from 'react';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import * as S from './skill-card-style';
import * as SS from './skill-image-style';
import { K_GRADE, PRE_K_GRADE, EARLY_LEARNING_PROGRAM, ELEMENTARY_SCHOOL_PROGRAM, AGE_THREE, AGE_FIVE } from '../../../constant-data/constants';
import { isNewCoqAssigned } from '../../../utils/feature_mapping';

const SkillCard = ({
  val,
  buildLearningPath,
  side,
  category,
  calculatePosition,
  subject,
  grade,
  cardHeight,
  cardWidth,
  rowWise
  }) => {
    const [reduceFontSize, setReduceFontSize] = useState(false);
    const skillNameWrapRef = useRef(null);
    const skillNameRef = useRef(null);
    const { getItem } = useExtendedLocalStorage('splashverse-onboarding', '');  
    const selectedAge = getItem('selectedAge');
    const selectedProgram = getItem('selectedProgram');
    const selectedGrade = getItem('selectedGrade');
    let customSelectedGrade = selectedGrade;
    const useCustomSelectedGrade = selectedAge && selectedProgram && (selectedProgram == EARLY_LEARNING_PROGRAM);
    if(useCustomSelectedGrade) {
      customSelectedGrade = selectedAge == AGE_FIVE ? K_GRADE : PRE_K_GRADE;
    }
    let customSelectedAge = selectedAge;
    const useCustomSelectedAge = selectedProgram == ELEMENTARY_SCHOOL_PROGRAM;
    if(useCustomSelectedAge) {
      customSelectedAge = customSelectedGrade == PRE_K_GRADE ? AGE_THREE : AGE_FIVE;
    }
    const shouldAddAgeClass = subject == 'ela' && (customSelectedGrade == PRE_K_GRADE || customSelectedAge == K_GRADE)
    const isNewCoqAbTest = isNewCoqAssigned();

    useEffect(()=>{
      (skillNameRef.current.offsetHeight 
        > skillNameWrapRef.current.offsetHeight) && 
      setReduceFontSize(true);
    },[])

  return (
    <S.SkillCard
      side={side}
      buildLearningPath={buildLearningPath}
      sideH={calculatePosition(val.index, category).left}
      sideV={calculatePosition(val.index, category).top}
      animationYOffset = {calculatePosition(val.index, category).animationYOffset}
      delay = {calculatePosition(val.index, category).delay}
      pausePosition = {calculatePosition(val.index, category).pausePosition}
      colorCat={category}
      data-set={val.index}
      cardHeight = {cardHeight}
      cardWidth = {cardWidth}
      rowWise = {rowWise}
      className={buildLearningPath ? `card-${val.card}` : `cat-${val.category} ${val.contentGroupCode}`}>
      <SS.Thumbnails className={`grade-${grade} subj-${subject}${shouldAddAgeClass && isNewCoqAbTest ? ` age-${customSelectedAge}` : ''} ${val.contentGroupCode} ${val.key}`} subject={subject} buildLearningPath={buildLearningPath} isNewCoqAbTest={isNewCoqAbTest}  />
      <SS.SkillInfoWrapper>
        <S.SkillNameWrap ref={skillNameWrapRef}>
          <S.SkillName ref={skillNameRef} reduceFontSize={reduceFontSize}>{val.skill}</S.SkillName>
        </S.SkillNameWrap>
        {val.skillCount && <S.SkillCount colorCat={category}>{val.skillCount} skills</S.SkillCount>}
      </SS.SkillInfoWrapper>
    </S.SkillCard>
  )
}

export default SkillCard;

